export const capitalize = (string) => string[0].toUpperCase() + string.slice(1)
